var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.54,
    height: 50.341,
    viewBox: "0 0 158.54 50.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M6.143 0C2.756 0 0 2.742 0 6.113v38.114c0 3.371 2.756 6.114 6.143 6.114h146.255c3.386 0 6.142-2.743 6.142-6.114V6.113c0-3.37-2.756-6.113-6.142-6.113z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M63.257 27.66c0 2.166-.646 3.891-1.937 5.176-1.467 1.53-3.376 2.295-5.728 2.295-2.25 0-4.162-.776-5.737-2.328-1.576-1.551-2.362-3.475-2.362-5.77 0-2.295.786-4.218 2.362-5.77 1.575-1.551 3.487-2.327 5.737-2.327 1.118 0 2.185.215 3.202.649 1.015.433 1.828 1.011 2.438 1.732l-1.371 1.365c-1.03-1.227-2.454-1.84-4.269-1.84-1.64 0-3.059.572-4.256 1.72-1.198 1.148-1.797 2.639-1.797 4.47 0 1.835.599 3.324 1.797 4.473 1.197 1.146 2.616 1.72 4.256 1.72 1.742 0 3.194-.577 4.355-1.732.755-.75 1.19-1.798 1.306-3.139h-5.661v-1.862h7.556c.073.405.11.794.11 1.169"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M66.678 32.09c.69.7 1.505 1.052 2.45 1.052.943 0 1.76-.352 2.45-1.052.689-.7 1.033-1.626 1.033-2.781 0-1.155-.344-2.082-1.034-2.782-.69-.701-1.506-1.05-2.45-1.05-.944 0-1.76.349-2.45 1.05-.689.7-1.034 1.627-1.034 2.782s.345 2.082 1.035 2.781zm-1.492-6.819c1.031-1.075 2.345-1.613 3.941-1.613 1.597 0 2.91.538 3.942 1.613 1.03 1.075 1.546 2.421 1.546 4.038 0 1.617-.515 2.963-1.546 4.037-1.031 1.076-2.345 1.614-3.942 1.614-1.596 0-2.91-.538-3.94-1.614-1.031-1.074-1.547-2.42-1.547-4.037s.516-2.963 1.546-4.038z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M78.077 32.09c.689.7 1.505 1.052 2.45 1.052.943 0 1.759-.352 2.45-1.052.689-.7 1.034-1.626 1.034-2.781 0-1.155-.345-2.082-1.035-2.782-.69-.701-1.506-1.05-2.45-1.05-.944 0-1.76.349-2.45 1.05-.69.7-1.033 1.627-1.033 2.782s.343 2.082 1.034 2.781zm-1.492-6.819c1.03-1.075 2.344-1.613 3.942-1.613 1.595 0 2.909.538 3.94 1.613 1.031 1.075 1.546 2.421 1.546 4.038 0 1.617-.515 2.963-1.545 4.037-1.032 1.076-2.346 1.614-3.941 1.614-1.598 0-2.912-.538-3.942-1.614-1.03-1.074-1.547-2.42-1.547-4.037s.516-2.963 1.547-4.038z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M92.787 33.142c.943 0 1.746-.348 2.406-1.04.66-.693.991-1.625.991-2.793 0-1.17-.33-2.1-.99-2.793-.66-.693-1.464-1.04-2.407-1.04-.93 0-1.728.35-2.395 1.05-.668.701-1.002 1.628-1.002 2.783s.334 2.082 1.002 2.781c.667.7 1.465 1.052 2.395 1.052zm-.152 6.494c-1.264 0-2.295-.313-3.092-.942-.8-.628-1.373-1.346-1.72-2.154l1.829-.758c.203.577.576 1.062 1.122 1.45a3.11 3.11 0 001.861.585c1.103 0 1.97-.328 2.602-.985.632-.657.947-1.548.947-2.673v-1.017h-.087c-.349.518-.843.952-1.481 1.298-.639.347-1.358.52-2.155.52-1.38 0-2.57-.542-3.572-1.624-1.002-1.083-1.503-2.425-1.503-4.027 0-1.602.501-2.945 1.503-4.028 1.002-1.081 2.192-1.623 3.572-1.623.797 0 1.516.173 2.155.519.638.347 1.132.78 1.48 1.3h.088v-1.473H98.1v10.068c0 1.819-.53 3.2-1.59 4.147-1.06.944-2.351 1.417-3.875 1.417z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M263.10915 34.391L265.11143 34.391 265.11143 18.888889 263.10915 18.888889z",
    transform: "translate(-163.375 .047)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M110.903 28.031c-.044-.606-.324-1.183-.839-1.732-.516-.549-1.281-.823-2.298-.823-.74 0-1.382.23-1.926.694-.544.461-.918 1.082-1.122 1.861zm-2.874 6.929c-1.612 0-2.922-.534-3.93-1.603-1.01-1.067-1.515-2.417-1.515-4.048 0-1.545.49-2.872 1.47-3.985.98-1.11 2.233-1.666 3.756-1.666 1.583 0 2.849.513 3.8 1.537.95 1.025 1.426 2.397 1.426 4.114l-.02.368h-8.428c.057 1.068.417 1.913 1.077 2.532.661.62 1.434.933 2.32.933 1.437 0 2.41-.608 2.918-1.82l1.785.736c-.348.823-.923 1.513-1.72 2.069-.798.554-1.779.833-2.94.833z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M120.735 26.255h3.353c.841 0 1.517-.283 2.025-.845.508-.563.763-1.183.763-1.862 0-.678-.255-1.299-.763-1.862-.508-.563-1.184-.844-2.025-.844h-3.353zm0 8.183h-2.003V18.936h5.312c1.321 0 2.464.437 3.43 1.31.965.875 1.448 1.975 1.448 3.302 0 1.328-.483 2.429-1.448 3.302-.966.873-2.109 1.31-3.43 1.31h-3.31z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M294.45428 34.391L296.45752 34.391 296.45752 18.888889 294.45428 18.888889z",
    transform: "translate(-163.375 .047)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M138.24 33.142c.828 0 1.58-.308 2.255-.921.675-.613 1.011-1.339 1.011-2.176-.565-.462-1.414-.693-2.546-.693-.974 0-1.706.21-2.2.628-.493.419-.74.909-.74 1.472 0 .52.224.931.675 1.234.45.303.965.456 1.546.456zm-.326 1.818c-1.132 0-2.08-.325-2.841-.975-.763-.649-1.144-1.508-1.144-2.576 0-1.155.45-2.06 1.35-2.717.9-.657 2.01-.985 3.332-.985 1.176 0 2.141.216 2.895.649v-.303c0-.78-.268-1.404-.804-1.873-.538-.47-1.198-.704-1.982-.704-.581 0-1.107.138-1.578.412-.472.274-.795.649-.97 1.125l-1.83-.78c.247-.634.734-1.222 1.46-1.763.725-.542 1.683-.812 2.875-.812 1.364 0 2.496.397 3.396 1.19.9.795 1.35 1.914 1.35 3.357v6.408h-1.917v-1.471h-.085c-.8 1.211-1.968 1.818-3.507 1.818z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M310.786991 38.896L308.718212 38.896 311.200177 33.5485556 306.80236 23.6111111 308.979422 23.6111111 312.158578 31.2327778 312.202271 31.2327778 315.294041 23.6111111 317.471103 23.6111111 310.786991 38.896",
    transform: "translate(-163.375 .047)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#02d9ff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M9.508 27.067c0-4.952 0-9.903-.003-14.854-.001-.608.119-1.163.55-1.622.17-.178.29-.226.498-.017 3.35 3.4 6.708 6.792 10.066 10.184 2.175 2.197 4.35 4.395 6.532 6.583.212.211.231.324.006.545A6829.17 6829.17 0 0011.16 43.75c-.324.324-.554.29-.865.05-.57-.435-.789-1.02-.789-1.715.001-2.933-.004-5.865-.006-8.798-.002-2.074 0-4.147 0-6.22h.01"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#00f665",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M11.398 9.492c.408-.004.695.114.971.268 6.82 3.8 13.64 7.602 20.465 11.394.313.174.306.27.065.508a703.48 703.48 0 00-4.552 4.502c-.162.162-.263.256-.481.034-5.426-5.502-10.86-10.996-16.293-16.493-.045-.045-.083-.1-.175-.213"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff0443",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M13.298 43.53c4.95-4.976 9.904-9.948 14.842-14.934.307-.31.45-.268.725.016a280.863 280.863 0 003.807 3.855c.224.225.243.316-.063.483-6.354 3.458-12.704 6.927-19.055 10.393-.105.058-.202.151-.256.186"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc600",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M41.75 26.484c-.021.558-.285.95-.686 1.243a8.49 8.49 0 01-.947.575c-1.92 1.057-3.849 2.102-5.765 3.165-.26.144-.413.137-.628-.083A417.878 417.878 0 0029.6 27.21c-.202-.201-.207-.312 0-.514 1.612-1.58 3.216-3.17 4.814-4.765.188-.188.323-.21.557-.077 1.898 1.07 3.806 2.124 5.71 3.185.587.327 1.045.751 1.07 1.445"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M212.700472 12.971L212.122962 12.971 212.122962 9.04966667 210.867257 9.04966667 210.867257 8.5 213.957127 8.5 213.957127 9.04966667 212.700472 9.04966667 212.700472 12.971",
    transform: "translate(-163.375 .047)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M214.85284 12.970056L215.43035 12.970056 215.43035 8.5 214.85284 8.5z",
    transform: "translate(-163.375 .047)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M216.566372 12.971L216.566372 8.5 217.142932 8.5 217.142932 12.4213333 219.09013 12.4213333 219.09013 12.971 216.566372 12.971",
    transform: "translate(-163.375 .047)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M60.588 11.063c0 .625-.187 1.122-.558 1.492-.424.442-.975.662-1.653.662-.648 0-1.2-.223-1.654-.671-.454-.448-.682-1.002-.682-1.664 0-.662.228-1.217.682-1.664a2.268 2.268 0 011.654-.67c.323 0 .632.062.923.186.294.126.528.291.703.5l-.395.393c-.297-.353-.708-.53-1.231-.53-.473 0-.881.164-1.227.496-.346.331-.518.761-.518 1.289 0 .529.172.959.518 1.29.346.33.754.496 1.227.496.503 0 .921-.166 1.257-.5.216-.216.343-.517.376-.905h-1.633v-.537h2.179c.022.117.032.229.032.337"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M62.116 13.117a1.31 1.31 0 01-.836-.27 1.455 1.455 0 01-.49-.765l.529-.219c.133.47.407.706.821.706.268 0 .475-.087.619-.26.143-.172.216-.406.216-.702v-3.06h.579v3.048c0 .487-.136.862-.406 1.127-.27.264-.614.395-1.032.395"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M230.589994 9.04966667L228.542112 9.04966667 228.542112 10.4672778 230.388625 10.4672778 230.388625 11.0046667 228.542112 11.0046667 228.542112 12.4213333 230.589994 12.4213333 230.589994 12.971 227.964602 12.971 227.964602 8.5 230.589994 8.5 230.589994 9.04966667",
    transform: "translate(-163.375 .047)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M231.764012 12.971L231.764012 8.5 232.466903 8.5 234.652513 11.9783889 234.677209 11.9783889 234.652513 11.1161111 234.652513 8.5 235.230024 8.5 235.230024 12.971 234.626867 12.971 232.340572 9.32544444 232.316826 9.32544444 232.340572 10.1867778 232.340572 12.971 231.764012 12.971",
    transform: "translate(-163.375 .047)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M76.734 11.063c0 .625-.185 1.122-.558 1.492-.423.442-.974.662-1.652.662-.648 0-1.2-.223-1.654-.671-.454-.448-.681-1.002-.681-1.664 0-.662.227-1.217.68-1.664a2.269 2.269 0 011.655-.67c.322 0 .63.062.924.186.292.126.527.291.703.5l-.396.393c-.297-.353-.707-.53-1.23-.53-.475 0-.883.164-1.229.496-.344.331-.517.761-.517 1.289 0 .529.173.959.517 1.29.346.33.754.496 1.228.496.503 0 .92-.166 1.257-.5.217-.216.343-.517.376-.905h-1.633v-.537h2.178c.022.117.032.229.032.337"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M243.886979 9.04966667L241.840047 9.04966667 241.840047 10.4672778 243.685611 10.4672778 243.685611 11.0046667 241.840047 11.0046667 241.840047 12.4213333 243.886979 12.4213333 243.886979 12.971 241.262537 12.971 241.262537 8.5 243.886979 8.5 243.886979 9.04966667",
    transform: "translate(-163.375 .047)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M245.061947 12.971L245.061947 8.5 245.640407 8.5 245.640407 12.4213333 247.586655 12.4213333 247.586655 12.971 245.061947 12.971",
    transform: "translate(-163.375 .047)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M248.09768 12.970056L248.67519 12.970056 248.67519 8.5 248.09768 8.5z",
    transform: "translate(-163.375 .047)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M90.982 11.063c0 .625-.187 1.122-.559 1.492-.423.442-.973.662-1.65.662a2.27 2.27 0 01-1.656-.671c-.454-.448-.68-1.002-.68-1.664 0-.662.226-1.217.68-1.664a2.27 2.27 0 011.655-.67c.321 0 .63.062.923.186.292.126.527.291.703.5l-.395.393c-.298-.353-.708-.53-1.23-.53-.474 0-.883.164-1.229.496-.346.331-.518.761-.518 1.289 0 .529.172.959.518 1.29.346.33.755.496 1.228.496.502 0 .92-.166 1.256-.5.217-.216.343-.517.376-.905h-1.632v-.537h2.178c.021.117.032.229.032.337"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M93.662 10.658h.968a.747.747 0 00.583-.243.788.788 0 00.22-.537.786.786 0 00-.22-.537.744.744 0 00-.583-.244h-.968zm0 2.36h-.576v-4.47h1.532c.38 0 .71.126.988.377.279.252.418.57.418.953 0 .382-.14.7-.418.951a1.418 1.418 0 01-.988.379h-.956z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M97.957 8.562a.237.237 0 00.175-.074.235.235 0 00.076-.175.235.235 0 00-.076-.175.242.242 0 00-.35 0 .235.235 0 00-.076.175.246.246 0 00.226.25zm-.747 2.723h1.494l-.735-2.016h-.025zm-1.275 1.748l1.6-4.22a.62.62 0 01-.231-.5c0-.183.063-.337.188-.462a.636.636 0 01.465-.188c.18 0 .334.065.462.191.127.128.19.28.19.46a.63.63 0 01-.232.499l1.603 4.22h-.642l-.433-1.211h-1.89l-.44 1.211z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppAndroid);
export default __webpack_public_path__ + "static/media/app-android.a19b7be8fbf7905c5637e8ae675ca799.svg";
export { ForwardRef as ReactComponent };